import { useState } from 'react'

export const TextEditor = ({ value, label, onSave, onClose }) => {
  const [text, setText] = useState(value ?? '')

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      onSave(text)
    }
    if (e.key === 'Escape') {
      onClose()
    }
  }

  return (
    <div className="flex flex-col gap-3">
      <input
        type="text"
        value={text}
        onChange={e => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={label}
        autoFocus
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent"
        aria-label={label}
      />
      <div className="builder-editor-actions">
        <button
          onClick={onClose}
          className="btn btn-secondary"
        >
          Annuler
        </button>
        <button
          onClick={() => onSave(text)}
          className="btn btn-primary"
        >
          Appliquer
        </button>
      </div>
    </div>
  )
}
